import { format, formatDistanceStrict } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Card,
  CardHeader,
  Col,
  Form,
  FormGroup,
  ListGroupItem,
  NavLink,
  Row,
} from 'shards-react';
import DateInput from '../../../common/form/DateInput';
import SelectInput from '../../../common/form/SelectInput';
import { RACE_DATA, STATE_DATA } from '../../../common/form/states.data';
import TelInput from '../../../common/form/TelInput';
import TextInput from '../../../common/form/TextInput';
import { fullName } from '../../../common/util/validation';
import { updateProfile, updateProfileImage } from './profileActions';

const mapState = (state) => ({
  providerId: state.firebase.auth.providerData[0].providerId,
  user: state.firebase.profile,
  auth: state.firebase.auth,
  statesArray: STATE_DATA,
  raceArray: RACE_DATA,
  currentYear: new Date().getFullYear(),
  initialValues: state.firebase.profile,
  documents: state.firestore.ordered.documents || [],
});

const actions = {
  updateProfile,
  updateProfileImage,
};

const validate = combineValidators({
  userFullName: isRequired('Full name'),
  userCitizenship: isRequired('Citizenship'),
  userNationalId: isRequired('National Id or Passport'),
  userDOB: isRequired('Date of Birth'),
  userGender: isRequired('Gender'),
  userAddress1: isRequired('Address 1'),
  userAddress2: isRequired('Address 2'),
  userAddressTown: isRequired('Town'),
  userAddressState: isRequired('State'),
  userAddressPostCode: isRequired('Post code'),
  userMobile: isRequired('Mobile Number'),
  userTel: isRequired('Tel Number'),
});

const ProfileComponent = ({
  handleSubmit,
  error,
  updateProfile,
  history,
  statesArray,
  raceArray,
  pristine,
  submitting,
  touched,
  invalid,
  user,
  updateProfileImage,
}) => {
  const [files, setfiles] = useState([]);
  const [image, setimage] = useState(null);

  const handleValidation = (e) => {
    e.preventDefault();
    console.log(e);
  };

  //Clean up file preview from memory
  useEffect(() => {
    return () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    };
  }, [files]);

  return (
    // TODO Complete Profile Update form, add modal before lodge complaint
    <div className='col-10 mx-auto'>
      <Card small className='my-2'>
        <CardHeader className='border-bottom card-header bg-primary1 d-flex align-items-center'>
          <NavLink
            as={Link}
            onClick={() => history.goBack()}
            className='text-white btn-transparent'
          >
            <MdArrowBack className='text-white' /> Back
          </NavLink>
          <h5 className='m-0 text-center'>Update Profile</h5>
        </CardHeader>

        <ListGroupItem flush='true' className='p-2'>
          <Form onSubmit={handleSubmit(updateProfile)}>
          <div className='text-danger my-2'>All fields marked as * are required</div>
            <ListGroupItem>
              User Details
              <Row>
                <Col md='6' lg='4' className='form-group'>
                  <label htmlFor='userFullName'>Full Name *</label>
                  <Field
                    component={TextInput}
                    name='userFullName'
                    type='text'
                    placeholder={''}
                    validate={fullName}
                  />


                </Col>
                <Col md='6' lg='4' className='form-group'>
                  <label htmlFor='userCitizenship'>Citizenship *</label>
                  <Field
                    component={SelectInput}
                    name='userCitizenship'
                    options={[
                      { label: '', value: '' },
                      { label: 'Malaysian', value: 'malaysian' },
                      { label: 'Foreigner', value: 'foreigner' },
                    ]}
                    type='text'
                    placeholder={''}
                  />
                </Col>
                <Col md='6' lg='4' className='form-group'>
                  <label htmlFor='userNationalId'>
                    NRIC or Passport Number *
                  </label>
                  <Field
                    name='userNationalId'
                    type='text'
                    component={TextInput}
                    placeholder='Enter a valid National ID'
                  />
                </Col>
              </Row>
              <Row>
                <Col md='12' className='form-group'>
                  <label htmlFor='userDOB'>
                    Date of Birth * :{' '}
                    {user.userDOB &&
                      format(user.userDOB.toDate(), 'dd MMM yyyy')}
                  </label>
                  <Field
                    name='userDOB'
                    type='date'
                    component={DateInput}
                    placeholder='Enter you date of birth'
                  />
                  Age:
                  {user.userDOB &&
                    formatDistanceStrict(user.userDOB.toDate(), new Date(), {
                      roundingMethod: 'floor',
                      unit: 'year',
                    })}
                </Col>
                <Col md='6' className='form-group'>
                  <label htmlFor='userGender'>Gender *</label>
                  <Field
                    component={SelectInput}
                    name='userGender'
                    options={[
                      { label: '', value: '' },
                      { label: 'Male', value: 'male' },
                      { label: 'Female', value: 'female' },
                    ]}
                    type='text'
                    placeholder={''}
                  />
                </Col>
              </Row>
            </ListGroupItem>
            <ListGroupItem>
              <strong>Contact Details </strong>
              <Row form>
                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='userAddress1'>Address Line 1 *</label>
                    <Field
                      component={TextInput}
                      type='text'
                      name='userAddress1'
                      placeholder={''}
                    />
                  </FormGroup>
                </Col>
                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='userAddress2'>Address Line 2 *</label>
                    <Field
                      component={TextInput}
                      type='text'
                      name='userAddress2'
                      placeholder={''}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md='4' className='form-group'>
                  <label htmlFor='userAddressTown'>Town *</label>
                  <Field
                    component={TextInput}
                    name='userAddressTown'
                    type='text'
                    placeholder={''}
                  />
                </Col>
                <Col md='4' className='form-group'>
                  <label htmlFor='userAddressState'>State *</label>
                  <Field
                    component={SelectInput}
                    name='userAddressState'
                    options={statesArray}
                    type='text'
                    placeholder={''}
                  />
                </Col>
                <Col md='4'>
                  <label htmlFor='userAddressPostCode'>Post Code *</label>
                  <Field
                    name='userAddressPostCode'
                    type='text'
                    component={TextInput}
                    placeholder={''}
                  />
                </Col>
              </Row>
              <Row>
                <Col className='form-group col-6'>
                  <label htmlFor='userTel'>Tel *</label>
                  <Field
                    name='userTel'
                    type='tel'
                    component={TelInput}
                    placeholder='E.g. 07-1234567, 071234567'
                  />
                </Col>
                <Col className='form-group col-6'>
                  <label htmlFor='userMobile'>Mobile *</label>
                  <Field
                    name='userMobile'
                    type='tel'

                    component={TelInput}
                    placeholder='E.g. 0123456789, 012-3456789'
                  />
                </Col>
                <Col className='form-group col-6'>
                  <label htmlFor='userOfficeContact'>Office</label>
                  <Field
                    name='userOfficeContact'
                    type='tel'
                    component={TelInput}
                    placeholder='E.g. 07-1234567, 071234567'
                  />
                </Col>
              </Row>
            </ListGroupItem>
            <ListGroupItem>
              <strong> Census Data </strong>
              <p>Your data will be kept anonymous in the analytics data.</p>
              <Row>
                <Col md='6' className='form-group'>
                  <label htmlFor='userRace'>Race</label>
                  <Field
                    name='userRace'
                    type='select'
                    component={SelectInput}
                    placeholder=''
                    options={raceArray}
                  />
                </Col>

                <Col md='6' className='form-group'>
                  <label htmlFor='userIncomeGroup'>Income Group</label>
                  <Field
                    name='userIncomeGroup'
                    type='select'
                    component={SelectInput}
                    options={[
                      { label: '', value: '' },
                      { label: 'RM 1,200 - 3,860', value: 'b40' },
                      { label: 'RM 3861 - 8,319', value: 'm40' },
                      { label: 'RM 8,320 and above', value: 't20' },
                    ]}
                    placeholder='Enter a valid phone number'
                  />
                </Col>
              </Row>
              <Row>
                <Col md='6' className='form-group'>
                  <label htmlFor='userEducation'>Education Level</label>
                  <Field
                    name='userEducation'
                    type='select'
                    component={SelectInput}
                    options={[
                      { label: '', value: '' },
                      {
                        label: 'Primary Education / Sekolah Rendah',
                        value: 'primary_education',
                      },
                      {
                        label:
                          'Lower Secondary Education / Sekolah Menengah Rendah',
                        value: 'lower_secondary_education',
                      },
                      {
                        label:
                          'Upper Secondary Education / Sekolah Menengah Atas',
                        value: 'upper_secondary_education',
                      },
                      {
                        label: 'Certificate / Sijil Kemahiran',
                        value: 'certificate',
                      },
                      { label: 'Diploma / Diploma', value: 'diploma' },
                      { label: 'Degree / Ijazah', value: 'degree' },
                      { label: 'Masters / Ijazah Lanjutan', value: 'masters' },
                      {
                        label: 'Doctorate / Ijazah Kedoktoran',
                        value: 'doctorate',
                      },
                    ]}
                    placeholder='Education Level'
                  />
                </Col>
                <Col md='6' className='form-group'>
                  <label htmlFor='userOccupation'>Occupation</label>
                  <Field
                    name='userOccupation'
                    type='select'
                    placeholder='Occupation'
                    component={SelectInput}
                    options={[
                      { label: '', value: '' },
                      {
                        label: 'Civil Servant / Kakitangan Kerajaan',
                        value: 'civil_servant',
                      },
                      {
                        label: 'Professional / Professional',
                        value: 'professional',
                      },
                      { label: 'Technical / Teknikal', value: 'technical' },
                      { label: 'Businessman / Peniaga', value: 'businessman' },
                      { label: 'Student / Pelajar', value: 'student' },
                      {
                        label: 'Own Business / Bekerja Sendiri',
                        value: 'own_business',
                      },
                      {
                        label: 'Unemployed / Tiada Bekerja',
                        value: 'unemployed',
                      },
                      { label: 'Others / Lain-Lain', value: 'others' },
                    ]}
                  />
                </Col>
              </Row>

              <Button
                theme='success'
                type='submit'
                disabled={pristine || submitting || invalid}
              >
                Update Profile
              </Button>
              {touched && error && (
                <label className='error-label'>{error}</label>
              )}
            </ListGroupItem>
          </Form>
        </ListGroupItem>
      </Card>
    </div>
  );
};

export default compose(
  connect(mapState, actions),
  reduxForm({ form: 'userProfile', enableReinitialize: true, validate })
)(ProfileComponent);
